var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import ThemeV3 from './ThemeV3';
const PREFERS_REDUCED_MOTION_QUERY = '(prefers-reduced-motion: reduce)';
function getOverriddenColors(colors, mode) {
    const { modes } = colors, colorsWithoutModes = __rest(colors, ["modes"]);
    const override = modes && modes[mode];
    if (override) {
        return {
            text: override.text || colors.text,
            background: override.background || colors.background,
            primary: override.primary || colors.primary,
            backgrounds: Object.assign(Object.assign({}, colors.backgrounds), override.backgrounds),
            interactions: Object.assign(Object.assign({}, colors.interactions), override.interactions),
            system: Object.assign(Object.assign({}, colors.system), override.system),
            dividers: Object.assign(Object.assign({}, colors.dividers), override.dividers),
            shadows: Object.assign(Object.assign({}, colors.shadows), override.shadows),
            overlay: override.overlay || colors.overlay,
        };
    }
    return colorsWithoutModes;
}
const getTheme = ({ device, mode = 'light', reducedMotion, themeOverride = ThemeV3, }) => {
    const { colors } = themeOverride, themeRest = __rest(themeOverride, ["colors"]);
    return Object.assign(Object.assign({}, themeRest), { mode,
        device, reducedMotion: reducedMotion !== null && reducedMotion !== void 0 ? reducedMotion : window.matchMedia(PREFERS_REDUCED_MOTION_QUERY).matches, colors: getOverriddenColors(colors, mode) });
};
export default getTheme;
